import { Button, ButtonProps } from '@chakra-ui/react';
import { Icons, defaultIconSize } from '@texas/components/shared/Icons';
import { suppliersApi } from '@texas/api/endpoints/suppliersApi';
import { useState } from 'react';
import {
  saveBlobAsFile,
  excelExportFileName,
  exportPrefixes,
} from '@texas/utils/helpers/filesHelper';
import { RoleRestrict } from '@texas/components/shared/RoleRestrict';
import { Role } from '@texas/api/endpoints/userApi';

interface ExportSuppliersButtonProps extends ButtonProps {
  supplierIds?: number[];
  organizationId: number;
}

export function ExportSuppliersButton({
  supplierIds,
  organizationId,
  isDisabled,
  children,
  ...buttonProps
}: ExportSuppliersButtonProps) {
  const [isExporting, setIsExporting] = useState(false);
  const exportDisabled =
    isDisabled ?? (!supplierIds || supplierIds.length === 0);

  const handleExport = async () => {
    if (!supplierIds || supplierIds.length === 0) return;

    setIsExporting(true);
    const response = await suppliersApi.downloadExcel({
      organizationId,
      supplierIds,
    });

    if (!response.hasError) {
      saveBlobAsFile(
        response.data,
        excelExportFileName(exportPrefixes.suppliers),
      );
    }
    setIsExporting(false);
  };

  return (
    <RoleRestrict allow={[Role.SystemAdministrator]}>
      <Button
        leftIcon={<Icons.FileExcelBox boxSize={defaultIconSize} />}
        onClick={handleExport}
        isDisabled={exportDisabled}
        isLoading={isExporting}
        {...buttonProps}
      >
        {children}
      </Button>
    </RoleRestrict>
  );
}
